import React from 'react';

const Hero = () => {
    return (
        <header className="hero" id="home">
            <div className="hero-mesh">
                <span></span><span></span><span></span>
            </div>
            <div className="hero-grid"></div>

            <div className="container hero-container">
                <div className="hero-content">
                    <span className="badge fade-up d1">Vendor App · For Salon Owners</span>

                    <h1 className="fade-up d2">
                        Run your salon smarter with<br />
                        <span className="highlight">My Salon Hub Vendor.</span>
                    </h1>

                    <p className="fade-up d3">
                        The all-in-one Vendor App built for Indian salon owners — manage bookings, staff, expenses,
                        and grow your business from your phone.
                    </p>

                    <div className="hero-buttons fade-up d4">
                        <a href="#demo-ios" className="btn-primary btn-large" id="hero-appstore-btn">
                            <i className="fa-brands fa-apple"></i> App Store Demo
                        </a>
                        <a href="#demo-android" className="btn-secondary btn-large" id="hero-playstore-btn">
                            <i className="fa-brands fa-google-play" style={{ color: '#17B298' }}></i> Play Store Demo
                        </a>
                    </div>

                    <div className="hero-stats fade-up d5">
                        <div className="hero-stat">
                            <div className="num">500+</div>
                            <div className="lbl">Salons Onboarded</div>
                        </div>
                        <div className="hero-stat">
                            <div className="num">₹42K+</div>
                            <div className="lbl">Avg. Monthly Revenue</div>
                        </div>
                        <div className="hero-stat">
                            <div className="num">24/7</div>
                            <div className="lbl">Online Bookings</div>
                        </div>
                    </div>
                </div>

                <div className="hero-visual fade-in d4">
                    <div className="float-tag float-tag-1">
                        <div className="dot" style={{ background: '#17B298' }}></div>
                        <span style={{ color: '#fff', fontSize: '0.82rem' }}>New booking: Rahul ✓</span>
                    </div>
                    <div className="float-tag float-tag-2">
                        <div className="dot" style={{ background: '#7C4DFF' }}></div>
                        <span style={{ color: '#fff', fontSize: '0.82rem' }}>Staff marked present</span>
                    </div>

                    <div className="hero-card">
                        <div className="card-header">
                            <div className="card-greeting">
                                <div className="hi">Good morning 👋</div>
                                <div className="name">Hello, Owner</div>
                                <div className="brand">My Salon Hub Vendor</div>
                            </div>
                            <div className="card-avatar">P</div>
                        </div>

                        <div className="rev-card">
                            <div className="rev-label">
                                <div className="rev-icon"><i className="fa-solid fa-indian-rupee-sign"></i></div>
                                Total Revenue
                            </div>
                            <div className="rev-amount">₹42,500</div>
                            <div className="rev-sub">↑ 18% from last month</div>
                        </div>

                        <div className="stats-row">
                            <div className="stat-pill">
                                <i className="fa-solid fa-scissors" style={{ color: '#17B298' }}></i>
                                <span className="s-label">Services</span>
                                <span className="s-value">12</span>
                            </div>
                            <div className="stat-pill">
                                <i className="fa-solid fa-tags" style={{ color: '#7C4DFF' }}></i>
                                <span className="s-label">Active Offers</span>
                                <span className="s-value">3</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Hero;
